import React from 'react';

import classes from './Intro.module.css'
import IntroNavItems from '../Intro/IntroNavItems/IntroNavItems'
const intro = ( props ) => (
    <div className={classes.Intro}>
        
        <IntroNavItems />
        
        
    </div>
)

export default intro;